// extracted by mini-css-extract-plugin
module.exports = {"ordered-list":"discussionList_ordered-list__teFM4","list-item":"discussionList_list-item__1VnYR"};